// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `project.json`.

import {
  AppEnvironment,
  buildEnvironment,
  type Environment,
} from "./environment.config";

export const environment: Environment = buildEnvironment(
  AppEnvironment.Development,
);

export { AppEnvironment };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

/**
 
Dev Run: npx nx serve website
Dev Build: npx nx build website --configuration=development

Prod Run: npx nx serve website --configuration=production
Prod Build: npx nx build website


 * 
 */
